const ReadyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="#F4BC4D" />
    <path d="M7 5L16 10L7 15V5Z" fill="#648C94" />
  </svg>
);

export default ReadyIcon;
